import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String }

  async share(event) {
    if (navigator.share) {
      try {
        await navigator.share({ title: this.titleValue, url: this.urlValue })
      } catch (error) {
        if (error.name !== "AbortError") throw error
      }
      return
    }

    try {
      await navigator.clipboard.writeText(this.urlValue)
      event.currentTarget.textContent = "Link copiado"
    } catch (_) {
      window.prompt("Copie o link do evento:", this.urlValue)
    }
  }
}
